import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';

let nextId = 0;

/**
 * One document to read and one box to tick, shared by `app-accept-legal-dialog` and
 * `app-legal-consent-dialog`. The wording, the unchecked default and the reachability of the
 * document text are what make the consent *informado*, *inequívoco* and *específico*, so the two
 * screens must not be able to drift apart.
 *
 * The sentence is a sibling of the checkbox, not its projected label: a control nested in a label
 * is activated by that label, so reading the terms would tick the box, and the link would not be
 * reachable as its own control. `aria-labelledby` restores the association, the click handler
 * restores tapping the sentence to tick, and the link stops propagation.
 */
@Component({
  selector: 'app-legal-consent-checkbox',
  templateUrl: './legal-consent-checkbox.component.html',
  standalone: true,
  imports: [CommonModule, MatCheckboxModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalConsentCheckboxComponent {
  /** The document's name, which is also the link inside the sentence. */
  @Input({ required: true }) titleKey!: string;

  @Input() checked = false;

  @Output() readonly checkedChange = new EventEmitter<boolean>();

  @Output() readonly documentOpened = new EventEmitter<void>();

  readonly labelId = `legal-consent-checkbox-label-${nextId++}`;
}
